import HttpClient from "@/services/HttpClient";
import StoreService from "@/store";
import { EServices } from "@/types";
import IJsonResponse from "@/utils/types/IJsonResponse";
import { inject, injectable } from "tsyringe";
import { IWalletMode } from "../types";

@injectable()
export default class WalletsClient {
  constructor(
    @inject(EServices.http) private http: HttpClient,
    @inject(EServices.store) private store: StoreService
  ) {}

  // async getAllWalletsInfo(): Promise<IJsonResponse> {
  async getAllWalletsInfo(): Promise<void> {
    // const response = await this.http.get("/v1/app/wallets");
    // this.store.commit("WalletsModule/setWalletsInfo", response.data);
    // return response;
    const dummyWalletsInfo = {
      adminWalletMode: true,
      mode: true,
      totalUsdBalance: 3150.75,
      totalNgnBalance: 1200000.75,
      wallets: [
        {
          id: 1,
          customer: {
            id: 2,
            accountId: 6,
            phone: "+2348012345678",
            createDate: new Date("2023-01-15T10:00:00Z"),
            updateDate: new Date("2024-06-01T10:00:00Z"),
            deleteDate: undefined,
          },
          balance: 0.035,
          usdBalance: 3150.75,
          ngnBalance: 850000.0,
          createDate: new Date("2023-02-10T09:30:00Z"),
          updateDate: new Date("2025-05-01T08:00:00Z"),
          deleteDate: undefined,
          currency: {
            id: 2,
            name: "Bitcoin",
            symbol: "btc",
            chain: "btc",
            blockchainExplorerUrl: "https://blockchain.info",
            rate: 30000,
            createDate: new Date("2022-05-10T10:00:00Z"),
            updateDate: new Date("2025-04-01T10:00:00Z"),
            deleteDate: undefined,
          },
          type: {
            id: 1,
            name: "main",
            slug: "wallettype__main",
            default: true,
          },
        },
        {
          id: 2,
          customer: {
            id: 2,
            accountId: 6,
            phone: "+2348012345678",
            createDate: new Date("2023-01-15T10:00:00Z"),
            updateDate: new Date("2024-06-01T10:00:00Z"),
            deleteDate: undefined,
          },
          balance: 100000,
          usdBalance: 449.5,
          ngnBalance: 350000.75,
          createDate: new Date("2023-03-15T11:00:00Z"),
          updateDate: new Date("2025-04-30T07:00:00Z"),
          deleteDate: undefined,
          currency: {
            id: 1,
            name: "Tether USD",
            symbol: "eth",
            chain: "eth",
            blockchainExplorerUrl: "https://etherscan.io",
            rate: 1,
            createDate: new Date("2022-06-01T10:00:00Z"),
            updateDate: new Date("2025-04-02T10:00:00Z"),
            deleteDate: undefined,
          },
          type: {
            id: 1,
            name: "main",
            slug: "wallettype__main",
            default: true,
          },
        },
      ],
    };

    this.store.commit("WalletsModule/setWalletsInfo", dummyWalletsInfo);
    // return response;
  }

  // async getSingleWalletInfo(
  //   currency: string,
  //   chain: string
  // ): Promise<IJsonResponse> {
  //   const response = await this.http.get(
  //     `/v1/app/wallets/${currency}/${chain}`
  //   );
  //   this.store.commit("WalletsModule/setWallet", response.data);
  //   return response;
  // }
  async getSingleWalletInfo(currency: string, chain: string): Promise<void> {
    const walletInfo = {
      id: 1,
      customer: {
        id: 2,
        accountId: 6,
        phone: "+2348012345678",
        createDate: new Date("2023-01-15T10:00:00Z"),
        updateDate: new Date("2024-06-01T10:00:00Z"),
        deleteDate: undefined,
      },
      balance: 0.035,
      usdBalance: 3150.75,
      ngnBalance: 850000.0,
      createDate: new Date("2023-02-10T09:30:00Z"),
      updateDate: new Date("2025-05-01T08:00:00Z"),
      deleteDate: undefined,
      currency: {
        id: 2,
        name: "Bitcoin",
        symbol: "btc",
        chain: "btc",
        blockchainExplorerUrl: "https://blockchain.info",
        rate: 30000,
        createDate: new Date("2022-05-10T10:00:00Z"),
        updateDate: new Date("2025-04-01T10:00:00Z"),
        deleteDate: undefined,
      },
      type: {
        id: 1,
        name: "main",
        slug: "wallettype__main",
        default: true,
      },
    };
    this.store.commit("WalletsModule/setWallet", walletInfo);
    // return response;
  }

  async getTransactions(
    currencySymbol: string = "",
    chain: string = "",
    page: number = 1,
    size: number = 20
  ): Promise<IJsonResponse> {
    const response = await this.http.get(`/v1/app/wallets/transactions`, {
      currencySymbol,
      chain,
      page,
      size,
    });
    this.store.commit("WalletsModule/setWalletActivity", response.data);
    return response;
  }

  async getTransactionsByCurrency(
    currencySymbol: string,
    chain: string,
    page: number = 1,
    size: number = 20
  ): Promise<IJsonResponse> {
    const response = await this.http.get(
      `/v1/app/wallets/transactions/${chain}/${currencySymbol}?page=${page}&size=${size}`
    );
    this.store.commit("WalletsModule/setSingleWalletActivity", response.data);
    return response;
  }

  async changeWalletMode(): Promise<IWalletMode> {
    const response = await this.http.patch("/v1/app/wallets/mode");
    return response.data;
  }

  async getWalletMode(): Promise<IWalletMode> {
    const response = await this.http.get("/v1/app/wallets/mode");
    return response.data;
  }

  async sell(
    amountCrypto: number,
    currencySymbol: string,
    chain: string
  ): Promise<IJsonResponse> {
    const response = await this.http.post(`/v1/app/wallets/sell`, {
      amountCrypto,
      currencySymbol,
      chain,
    });
    return response;
  }

  async sellAll(currencySymbol: string, chain: string): Promise<IJsonResponse> {
    const response = await this.http.post(`/v1/app/wallets/sell/all`, {
      amountCrypto: 0,
      currencySymbol,
      chain,
    });
    return response;
  }

  async transfer(
    amountCrypto: number,
    currency: string,
    accountId: number,
    chain: string
  ): Promise<IJsonResponse> {
    const response = await this.http.post(`/v1/app/wallets/transfer`, {
      amountCrypto,
      currency,
      recipient: accountId,
      chain,
    });
    return response;
  }

  async swap(
    fromCurrencySymbol: string,
    toCurrencySymbol: string,
    walletType: string,
    amountCrypto: number,
    fromChain: string,
    toChain: string
  ): Promise<IJsonResponse> {
    const response = await this.http.post(`/v1/app/wallets/swap`, {
      fromCurrencySymbol,
      toCurrencySymbol,
      walletType,
      amountCrypto,
      fromChain,
      toChain,
    });
    return response;
  }
}
